import img1 from '../assets/Favorite.jpg'
import img2 from '../assets/slidermain.jpg'
import img3 from '../assets/Favorite2.jpg'
export const sliderData = [
    {
      image: img1,
      heading: "Welcome to DiyaKaran Enterprises",
      desc: "Authorized distributers for Anthem Biosciences, Bangalore.",
      text:"Get Started",
    },
    {
      image: img2,
      heading: "API,Nutritional Actives,Vitamin Analogues,enzymes and many more",
      desc: " Our aim is to bridge the gap between manufacturers and their users",
      text:"Check out our Products"
    },
    {
      image: img3,
      heading: "Our Vision",
      desc: "With the support of Anthem Biosciences, we aspire to formulate trust with our clients across Karnataka, Tamil Nadu and Pudducherry",
      text:"Connect with us",
    },
  ];